import { useState } from 'react';
import { Menu } from '../../theme/icons.js';
import { IconButton } from '../ui/Button.js';
import { SideNav } from './SideNav.js';
import { useRole } from '../../hooks/useRole.js';
import './AppShell.css';

export function AppShell({ page, onNavigate, onLogout, children }) {
  const [navOpen, setNavOpen] = useState(false);
  const { role } = useRole();

  return (
    <div className="app-shell">
      {/* Mobile overlay */}
      {navOpen && <div className="nav-overlay visible" onClick={() => setNavOpen(false)} />}

      <SideNav
        page={page}
        onNavigate={onNavigate}
        onLogout={onLogout}
        role={role}
        isOpen={navOpen}
        onClose={() => setNavOpen(false)}
      />

      <div className="app-main">
        {/* Mobile top bar */}
        <div className="mobile-topbar">
          {/* Derselbe Icon-Knopf wie überall statt eines rohen Buttons mit acht
              Inline-Eigenschaften: 32 × 27 px war die kleinste Berührfläche der
              ganzen Oberfläche — auf dem Gerät, auf dem sie am meisten zählt
              (Audit A2, C2). aria-expanded sagt Vorlesesoftware, ob die
              Navigation offen ist. */}
          <IconButton
            variant="standard"
            icon={<Menu size={22} />}
            label="Navigation öffnen"
            aria-expanded={navOpen}
            onClick={() => setNavOpen(true)}
          />
          <div className="logo-text">
            DV Limburg <span>Dashboard</span>
          </div>
        </div>

        {/* <main>, nicht <div>: das einzige Landmark für den Seiteninhalt.
            Vorlesesoftware springt damit direkt zum Inhalt (Audit B9). */}
        <main className="app-content">{children}</main>
      </div>
    </div>
  );
}
